<template>
  <el-card>
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">Bitrate Data</span>
    </div>
    <div
        v-loading="loading"
        class="card-content">
      <div v-if="dataLoaded">
        <el-row :gutter="20">
          <el-col
              v-for="(value, key) in images"
              :key="key"
              :span="spanPerImage">
            <img
                :src="'data:image/svg+xml;base64,' + value"
                style="width: 100%;">
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <div style="text-align: center; margin: 40px;">
          <a
              class="el-button el-button--primary"
              @click="loadImages()">
            Load Bitrate data <i class="el-icon-download"></i>
          </a>
          <div style="text-align: center">
            <small>This request may take a while</small>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: eventActions } = createNamespacedHelpers("event");
const { mapGetters } = createNamespacedHelpers("db/device");
export default {
  name: "EventBitrate",
  props: {
    event: { type: Object, required: true },
  },
  data() {
    return {
      loading: false,
      dataLoaded: false,
      images: {},
    };
  },
  computed: {
    ...mapGetters(["device"]),
    spanPerImage() {
      let k = Object.keys(this.images);
      if (k.length > 0) return 24 / k.length;
      else return 24;
    },
  },
  methods: {
    ...eventActions(["getBitRateData"]),
    loadImages() {
      this.loading = true;
      let ding_created_at = new Date(this.event.created_at);
      let ding_timestamp = ding_created_at.getTime();
      let duration = this.event.duration_ms || 30000; // fallback to 30 seconds if duration is broken
      let end_timestamp = new Date(ding_timestamp + duration).getTime();
      this.getBitRateData({
        start_timestamp: ding_timestamp,
        end_timestamp: end_timestamp,
        doorbotId: this.device.doorbot_id,
      })
        .then((response) => {
          // Normalize the images data structure
          let imagesData = response.data.images;

          // If images is a string (error case), convert it to an object
          if (typeof imagesData === "string") {
            imagesData = { 0: imagesData };
          }
          // If images is an array, convert it to an object with numeric keys
          else if (Array.isArray(imagesData)) {
            const imageObj = {};
            imagesData.forEach((img, index) => {
              imageObj[index.toString()] = img;
            });
            imagesData = imageObj;
          }

          this.images = imagesData;
          this.dataLoaded = true;
        })
        .catch((error) => {
          this.$notify.error({
            title: "Bitrate",
            message:
              error.data && error.data.message
                ? error.data.message
                : "An error occurred loading bitrate data",
          });
          console.log("Error loading bitrate", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
